var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkUploadIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44953",
    "data-name": "Group 44953",
    transform: "translate(64 -613)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63940",
    "data-name": "Rectangle 63940",
    width: 25,
    height: 25,
    transform: "translate(-64 613)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44938",
    "data-name": "Group 44938",
    transform: "translate(-61.75 615.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44575",
    "data-name": "Group 44575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89198",
    "data-name": "Path 89198",
    d: "M8.029,20.182H1.551a.8.8,0,0,1-.8-.8V1.551a.8.8,0,0,1,.8-.8H9.536A.8.8,0,0,1,10.1.984l4.973,4.971a.8.8,0,0,1,.235.567V8.265",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x2: 4.301,
    transform: "translate(3.551 10.466)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x2: 2.508,
    transform: "translate(3.551 14.64)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89199",
    "data-name": "Path 89199",
    d: "M9.621.755V5.469a.8.8,0,0,0,.8.8h4.845",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_378",
    "data-name": "Ellipse 378",
    cx: 5.378,
    cy: 5.378,
    r: 5.378,
    transform: "translate(9.029 9.994)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    y2: 4.687,
    transform: "translate(14.626 13.25)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89200",
    "data-name": "Path 89200",
    d: "M12.126,15.1l2.38-2.039,2.62,2.039",
    transform: "translate(0 -0.296)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUploadIco);
export default __webpack_public_path__ + "static/media/bulk-upload-ico.1fa06d019f1c912d90f9be1c66c146e5.svg";
export { ForwardRef as ReactComponent };